import React from 'react'
import _ from 'lodash'

import {Link} from 'react-router'

import {Cell} from 'fixed-data-table'
import DefaultCell from './DefaultCell.jsx'

//
const LinkCell = ({field, item, link, value, defaultValue, row, ...props}) => {
   const target = _.isFunction(link) ? link(row) : link

   return (
      <Cell {...props}>
         <Link to={{pathname: target}}>{value || defaultValue}</Link>
      </Cell>
   )
}

LinkCell.propTypes = {
   ...DefaultCell.propTypes,
   link: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string])
}

export default LinkCell



// WEBPACK FOOTER //
// lib/ui/table/LinkCell.jsx